<section class="e-tax-invoice-scoreboard">
  <div class="box">
    <ng-container *ngFor="let item of serviceList">
      <div class="box-left">
        <div class="box-left__content"
          ><span
            >{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.TITLE.1' | translate }}<br />
            {{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.TITLE.2' | translate }}</span
          ></div
        >
      </div>
      <div class="box-right">
        <div class="box-right__wrapper">
          <div class="box-right__wrapper--number"
            ><span>{{ item.data.businesses.iv | number }}+</span></div
          >
          <div class="box-right__wrapper--title"
            ><span
              >{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.CONTENT.BUSINESSES.TITLE.1' | translate
              }}<br />{{
                'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.CONTENT.BUSINESSES.TITLE.2' | translate
              }}</span
            >
          </div>
        </div>
        <div class="box-right__line"></div>
        <div class="box-right__wrapper">
          <div class="box-right__wrapper--number"
            ><span>{{ item.data.eTaxInvoices.iv | number }}+</span></div
          >
          <div class="box-right__wrapper--title"
            ><span
              >{{
                'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.CONTENT.E_TAX_INVOICES.TITLE.1' | translate
              }}<br />{{
                'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SCOREBOARD.CONTENT.E_TAX_INVOICES.TITLE.2' | translate
              }}</span
            >
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
